const planUtils = {
    getIconForPlan: function (plan) {
        if (plan == "public") return "far fa-globe";
        if (plan == "research") return "far fa-microscope";
        if (plan == "sandbox") return "far fa-umbrella-beach";
        if (plan == "growth-ubp") return "far fa-cubes";
        if (plan == "growth") return "far fa-seedling";
        if (plan == "enterprise") return "far fa-building";
        if (plan == "starter") return "far fa-star";
        if (plan == "growth-ubp") return "far fa-cubes";
        if (plan == "trial") return "far fa-gift";
        if (plan == "basic") return "far fa-cube";
        if (!plan) return "far fa-sparkle";

        return "far fa-scroll-old";
    },

    getTitleForPlan: function (plan, isTrial = false) {
        if (plan == "public") return "Public Plan";
        if (plan == "research") return "Research Plan";
        if (plan == "sandbox") return "Sandbox Plan";
        if (plan == "growth") return "Growth Plan";
        if (plan == "enterprise") return "Enterprise Plan";
        if (plan == "starter") return "Starter Plan";
        if (plan == "trial" || isTrial) return "Premium Trial";
        if (plan == "basic") return "Basic Plan";
        if (plan == "growth-ubp") return "Growth Plan";
        if (!plan) return "New Workspace";

        return "Legacy Plan";
    },

    getDescriptionForPlan: function (plan) {
        if (plan == "public") return "For personal work, open source projects, and research.";
        if (plan == "basic")
            return "For startups and small teams building their first computer vision application.";
        if (plan == "growth-ubp")
            return "For teams looking to build and deploy production models at scale.";
        if (plan == "trial")
            return "For teams looking to test premium features while building and deploying models.";
        if (plan == "enterprise")
            return "For scaled organizations with advanced deployment, security, and control needs.";
        if (plan == "starter")
            return "Enjoy premium features, expanded limits, and priority support.";
    },

    getTaglineForPlan: function (plan) {
        if (plan == "public") return "For open source";
        if (plan == "basic") return "For small teams";
        if (plan == "growth-ubp" || plan == "trial") return "For startups";
        if (plan == "enterprise") return "For organizations";
        if (plan == "starter") return "For premium features";
    },

    getSupportForPlan: function (plan) {
        if (plan == "public" || plan == "basic" || plan == "sandbox" || plan == "research")
            return "Community Support";
        if (plan == "growth-ubp")
            return "Priority Chat and Email Support, Onboarding with Specialists";
        if (plan == "enterprise") return "Dedicated Field Engineering Support";
        return "Priority Support";
    }
};

module.exports = planUtils;
